<template>
  <c-model
    ref="linkModelContent"
    title="招考环节(按开始时间排序)"
    width="50%"
    @confirm="saveInfo()"
    @cancel="cancel()"
  >
    <el-button
      type="primary"
      size="small"
      @click="addItem"
    >增加招考环节</el-button>

    <el-form
      ref="linkForm"
      :model="dataList"
    >
      <el-table
        :data="dataList.rows"
        class="table-center linkModel"
      >
        <el-table-column
          prop="name"
          label="环节名称"
        >
          <template slot-scope="{row,$index}">
            <el-form-item
              label="环节名称"
              :prop="'rows.'+$index+'.name'"
              hiddenLabel
              hiddenErrorText
              required
            >
              <el-input v-model="row.name"></el-input>
            </el-form-item>
          </template>

        </el-table-column>
        <el-table-column
          prop="startTime"
          label="开始时间"
        >
          <template slot-scope="{row,$index}">
            <el-form-item
              label="开始时间"
              :prop="'rows.'+$index+'.startTime'"
              hiddenLabel
              hiddenErrorText
              required
            >
              <el-date-picker
                v-model="row.startTime"
                type="datetime"
                placeholder="选择开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>

          </template>

        </el-table-column>
        <el-table-column
          prop="endTime"
          label="结束时间"
        >
          <template slot-scope="{row,$index}">
            <el-form-item
              label="结束时间"
              :prop="'rows.'+$index+'.endTime'"
              hiddenLabel
              hiddenErrorText
              required
            >
              <el-date-picker
                v-model="row.endTime"
                type="datetime"
                placeholder="选择结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>

          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="80px"
        >
          <template slot-scope="{row,$index}">
            <div class="actions">
              <a @click="deleteItem($index)">删除</a>
            </div>
          </template>

        </el-table-column>
      </el-table>
    </el-form>
  </c-model>
</template>

<script>
import TableMixin from "@/mixins/TableMixin";
export default {
  mixins: [TableMixin],
  props: {
    data: {
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      dataList: {
        rows: []
      },
      info: {}
    };
  },
  watch: {
    data(newData) {
      var rows = JSON.parse(JSON.stringify(newData));
      this.dataList = { rows };
    }
  },
  methods: {
    open() {
      this.openModel("linkModelContent");
    },
    close() {
      this.closeModel("linkModelContent");
    },
    cancel() {
      //点击取消，数据还原
      this.dataList = { rows: this.data };
    },
    saveInfo() {
      this.$refs.linkForm.validate(valid => {
        if (valid) {
          //判断是否有重名的环节
          var { rows } = this.dataList;
          var flag = false;
          for (var i = 0, len = rows.length; i < len; i++) {
            var item1 = rows[i];
            for (var j = 1; j < len; j++) {
              var item2 = rows[j];
              if (i !== j) {
                if (item1.name === item2.name) {
                  flag = true;
                  break;
                }
              }
            }
            if (flag) {
              break;
            }
          }
          if (flag) {
            this.$message.error("招考环节名称不能重复!");
            return;
          }
          //按开始时间排序
         rows =  rows.sort((a,b)=>{
            var a_startTime = new Date(a.startTime)
            var b_startTime = new Date(b.startTime)
            if(a_startTime < b_startTime){
              return -1
            }else if (a_startTime >b_startTime){
              return 1
            }
            return 0
          })
          console.log(rows)

          this.$emit("saveLink", rows);
        }
      });
    },
    addItem() {
      this.dataList.rows.push({});
    },
    deleteItem(index) {
      this.dataList.rows.splice(index, 1);
      console.log(index);
    }
  }
};
</script>

<style lang="scss" scoped>
.linkModel {
  .el-date-editor.el-input {
    width: 100%;
  }
}
</style>

